/**
 * Firebase Configuration
 * Manages Firebase initialization and configuration for different environments
 */

// Environment detection
const isProduction = window.location.hostname === 'auth.firesite.io';
const isDevelopment = !isProduction;

// Firebase configurations
const firebaseConfigs = {
  production: {
    apiKey: "AIzaSyCsstP1_EX71klGik7GCaDbUupxagPfdYA",
    authDomain: "auth.firesite.io",
    projectId: "firesiteusers",
    storageBucket: "firesiteusers.appspot.com",
    messagingSenderId: "528613868748",
    appId: "1:528613868748:web:342fd4e9de2456c8cf6e69",
    measurementId: "G-GTR7V7DTE9"
  },
  development: {
    apiKey: "AIzaSyCsstP1_EX71klGik7GCaDbUupxagPfdYA",
    authDomain: "auth.firesite.io",
    projectId: "firesiteusers",
    storageBucket: "firesiteusers.appspot.com",
    messagingSenderId: "528613868748",
    appId: "1:528613868748:web:342fd4e9de2456c8cf6e69",
    measurementId: "G-GTR7V7DTE9"
  }
};

// Export the appropriate configuration
export const firebaseConfig = isProduction 
  ? firebaseConfigs.production 
  : firebaseConfigs.development;

// Export environment flags
export const environment = {
  isProduction,
  isDevelopment,
  apiUrl: isProduction 
    ? 'https://us-central1-firesiteusers.cloudfunctions.net/api'
    : 'http://localhost:5000/firesiteusers/us-central1/api'
};

// Authentication settings
export const authSettings = {
  // Session persistence
  persistence: 'local', // 'local', 'session', or 'none'
  
  // Token refresh settings
  tokenRefreshInterval: 30 * 60 * 1000, // 30 minutes
  tokenRefreshBuffer: 5 * 60 * 1000, // 5 minutes before expiry
  
  // Verification settings
  emailVerificationRequired: true,
  phoneVerificationRequired: false,
  
  // Password policy
  passwordMinLength: 8,
  passwordRequireUppercase: true,
  passwordRequireLowercase: true,
  passwordRequireNumbers: true,
  passwordRequireSpecialChars: true,
  
  // Account settings
  allowMultipleAccounts: false,
  requireOrganization: false,
  
  // Rate limiting (enforced server-side)
  maxLoginAttempts: 5,
  lockoutDuration: 15 * 60 * 1000, // 15 minutes
};

// Export default configuration object
export default {
  firebase: firebaseConfig,
  environment,
  auth: authSettings
};